import {
    CheckBox,
    Flex,
    Icon,
    Input,
    PriorityIcon,
    Text,
    Title
} from '@priority-software/priority-style-react';
import React, {createRef, useContext, useEffect, useMemo} from 'react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {helpPopoverRef} from '../../../_shared/Help/constants';
import {AppSearchesContext} from '../AppSearchesContext';
import styles from './styles.module.scss';

const General = () => {
    const {search, fields, handleChangeDefault, handleChangeDefaultAbsolute, handleChangeName} =
        useContext(AppSearchesContext);
    const {name, isAbsoluteDefault, isDefault} = search;

    const inputRef = createRef<HTMLInputElement>();
    useEffect(() => {
        fields?.length > 0 && inputRef?.current?.focus();
    }, []);

    const onHelp = e => {
        e.stopPropagation();
        helpPopoverRef.current.showHelpPopover({
            content: getLocalizedText(texts.FixedSearchDesc),
            anchor: e.target
        });
    };

    return useMemo(
        () => (
            <Flex
                componentClasses={styles.generalBox}
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <Title textColor="primary-700" skin="h4">
                    {getLocalizedText(texts.AppSearchGeneralTitle)}
                </Title>
                <Flex
                    componentClasses={styles.content}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    direction="column"
                >
                    <Flex
                        componentClasses={styles.inputWrppaer}
                        alignItems="flex-start"
                        direction="column"
                        justifyContent="flex-start"
                    >
                        <Text
                            wrap={false}
                            componentClasses={styles.searchInputLabel}
                            textColor="primary-700"
                            skin="paragraph-2"
                        >
                            {getLocalizedText(texts.NameYourSearch)}
                        </Text>
                        <Input
                            onChange={e => handleChangeName(e.target.value)}
                            value={name}
                            inputRef={inputRef}
                            maxLength={48}
                            size="large"
                            placeholder={getLocalizedText(texts.SearchNameDefault)}
                        />
                    </Flex>
                    <CheckBox
                        checked={isDefault}
                        componentClasses={styles.defaultCheckbox}
                        onChange={handleChangeDefault}
                    >
                        <Text textColor="primary-700" skin="paragraph-2">
                            {getLocalizedText(texts.AppSearchSetDefault)}
                        </Text>
                    </CheckBox>
                    <CheckBox
                        onChange={handleChangeDefaultAbsolute}
                        style={{margin: '10px 30px', alignItems: 'center'}}
                        disabled={!isDefault}
                        checked={isAbsoluteDefault}
                    >
                        <Flex justifyContent="flex-start">
                            <Text
                                style={{marginRight: '5px'}}
                                textColor={isDefault ? 'primary-700' : 'secondary-300'}
                                skin="paragraph-2"
                            >
                                {getLocalizedText(texts.FixedSearch)}
                            </Text>
                            <Icon icon={PriorityIcon.help} onClick={onHelp} />
                        </Flex>
                    </CheckBox>
                </Flex>
            </Flex>
        ),
        [search]
    );
};

export default General;
